import { useCallback } from 'react';

import { useQueryCriteriasState } from '../query/useQueryCriteriasState';
import { useIsCatalogESIndex } from '../useIsCatalogESIndex';
import { createBlankCriteria } from '../../utils/createBlankCriteria';
import { createBlankCriteriaForCatalog } from '../../utils/createBlankCriteriaForCatalog';
import { useQueryStateContext } from '../../contexts';

export const useAddCriteria = () => {
  const { defaultCombinator: combinator, setToLatestId } = useQueryStateContext();
  const isCatalogESIndex = useIsCatalogESIndex();
  const { setCriterias } = useQueryCriteriasState();
  return useCallback(() => {
    const newCriteria = isCatalogESIndex
      ? createBlankCriteriaForCatalog(combinator)
      : createBlankCriteria({ combinator });
    setCriterias((criterias) => [...criterias, newCriteria]);
    setToLatestId(newCriteria.id);
  }, [setCriterias]);
};
